export class InternalOrderImportModel {
  counter: number = 0;
  companyId: number = 0;
  branchCode: number = 0;
  internalOrderNumber: number = 0;
  alterNumber: number | null = null;
  internalOrderDate: Date = new Date();
  responsible: string | null = null;
  observation: string | null = null;
  internalOrderState: number = 0;
  maintenanceOrderClass: number | null = null;
  maintenanceOrderNumber: number | null = null;
  articleCode: number = 0;
  quotationNumber: number | null = null;
  swUrgent: boolean = false;
  quantity: number = 0;
  constructor(
    counter: number,
    companyId: number,
    branchCode: number,
    internalOrderNumber: number,
    alterNumber: number | null,
    internalOrderDate: Date,
    responsible: string | null,
    observation: string | null,
    internalOrderState: number,
    maintenanceOrderClass: number | null,
    maintenanceOrderNumber: number | null,
    articleCode: number,
    quotationNumber: number | null,
    swUrgent: boolean,
    quantity: number
  ) {
    this.counter = counter;
    this.companyId = companyId;
    this.branchCode = branchCode;
    this.internalOrderNumber = internalOrderNumber;
    this.alterNumber = alterNumber;
    this.internalOrderDate = internalOrderDate;
    this.responsible = responsible;
    this.observation = observation;
    this.internalOrderState = internalOrderState;
    this.maintenanceOrderClass = maintenanceOrderClass;
    this.maintenanceOrderNumber = maintenanceOrderNumber;
    this.articleCode = articleCode;
    this.quotationNumber = quotationNumber;
    this.swUrgent = swUrgent;
    this.quantity = quantity;
  }
}